import { FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import _ from 'lodash';
import * as Yup from 'yup';

/**
 * 贵宾休息室预约查询
 */
export interface LoungeInfo {
  /**
   * 页数
   */
  page?: number;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 会员号
   */
  user_code?: string;
  /**
   * 会员等级 3奕尊 4奕尚
   */
  level?: number;
  /**
   * 预约时间段(取number字段 多选 以逗号隔开 12:00,13:00,14:00)
   */
  number?: string[];
  /**
   * 预约时间(start_date、end_date)
   */
  time_range?: string[];
}

/**
 * 贵宾休息室详情
 */
export interface LoungeDetailInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 预约时间
   */
  number?: string;
  /**
   * 入场人数
   */
  content?: string;
  /**
   * 入场时间
   */
  write_off_time?: string;
  /**
   * 离场时间
   */
  check_out_time?: string;
}

/**
 * 贵宾休息室预约查询表单默认值
 */
export const defaultInfo: LoungeInfo = {
  page: 1,
  phone: '',
  user_code: '',
  number: [],
  time_range: [dayjs().format(FULL_DATE), dayjs().format(FULL_DATE)]
};

/**
 * 贵宾休息室详情表单默认值
 */
export const defaultDetailInfo: LoungeDetailInfo = {
  remark: '',
  number: '',
  content: '',
  write_off_time: '',
  check_out_time: '',
};

/**
 * 贵宾休息室详情表单校验
 */
export const loungeSchema = Yup.object().shape(
  {
    // courier_company: Yup.string().ensure().required('请输入快递公司'),
    // money: Yup.string().ensure().required('请输入收费总计').matches(/^\d+(\.(\d)*)?$/, '请输入正确的金额'),
    // num: Yup.string().ensure().required('请输入物品数量').matches(/^[1-9]\d*$/, '请输入正确的数量'),
    // is_not_pay: Yup.number().typeError('请选择是否到付').required('请选择是否到付'),
    // expressage_items: Yup.array()
    //   .of(
    //     Yup.object({
    //       expressage_no: Yup.string().ensure().required('请输入快递单号'),
    //     })
    //   )
    //   .min(1, '请输入商品快递信息')
    //   .required('请输入商品快递信息'),
  }
);